import { isArray } from 'util';
import { Print } from '../print';

export class PrintBuilder {
  static fromJson(json) {
    return (json)
      ? new Print(
        json.hash,
        json.reference,
        json.material,
        json.operationProcess,
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(PrintBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/print.builder.ts